import PhoneMask from "../phoneMask";

/**
 * Componente para mostrar los datos centrales de la empresa en el PDF
 * @param {*} empresa Objeto completo de la empresa
 * @param {*} regimenFiscal Si debe mostrar el regimen fiscal
 * @param {*} tipoComprobante Si debe mostrar el tipo de comprobante
 * @param {*} terceraColumna Objeto con la tabla de datos del comprobante
 * @returns Array con las 3 columnas listas para insertarse en el body de la tabla
 */
export const HeaderEmpresaCard = (
  empresa = {},
  regimenFiscal = true,
  tipoComprobante = 'ingreso',
  terceraColumna = {},
) => {
  let contacto = [];
  if (empresa?.telefono) contacto.push(`Tel: ${PhoneMask(empresa.telefono)}`);
  if (empresa?.correo) contacto.push(empresa.correo);
  const lineaContacto = contacto.join(" | ");
  const textoComprobante = 
    (typeof tipoComprobante === 'string' && tipoComprobante.toLowerCase() === 'egreso')
      ? "Tipo De Comprobante: (E) Egreso"
      : "Tipo De Comprobante: (I) Ingreso";

  return [
    // -- PRIMERA COLUMNA: LOGO ---
    {
      border: [false, false, false, false],
      image: "logo",
      fit: [80, 80],
    },

    // --- SEGUNDA COLUMNA: DATOS DE LA EMPRESA ---
    {
      border: [false, false, false, false],
      table: {
        headerRows: 1,
        widths: ["100%"],
        body: [
          [
            {
              text: empresa?.nombreComercial
                ? empresa.nombreComercial
                : empresa?.persona
                  ? empresa.nombre
                  : `${empresa?.nombre || ""} ${empresa?.apellidoPaterno || ""} ${empresa?.apellidoMaterno || ""}`,
              style: "tableHeader",
            },
          ],
          [
            {
              text: "R.F.C: " + (empresa?.rfc || ""),
              style: "textoChico",
              alignment: "center",
            },
          ],
          [
            {
              text:
                (empresa?.calle || "") +
                " " +
                (empresa?.numeroCalle || "") +
                " " +
                (empresa?.numeroInterior ? empresa.numeroInterior : ""),
              style: "textoChico",
              alignment: "center",
            },
          ],
          [
            {
              text:
                (empresa?.colonia?.tipoAsentamiento || "") +
                " " +
                (empresa?.colonia?.nombre || "") +
                " C.P. " +
                (empresa?.colonia?.cp || "") +
                " " +
                (empresa?.municipio?.nombre || "") +
                " " +
                (empresa?.estado?.abreviatura || "") +
                " " +
                (empresa?.pais?.abreviatura || "") +
                " ",
              style: "textoChico",
              alignment: "center",
            },
          ],
          ...(lineaContacto
            ? [
                [
                  {
                    text: lineaContacto,
                    style: "textoChico",
                    alignment: "center",
                  },
                ],
              ]
            : []),
          ...(regimenFiscal && empresa?.regimenFiscal
            ? [
                [
                  {
                    text: `Regimen Fiscal: (${empresa?.regimenFiscal?.c_RegimenFiscal}) ${empresa?.regimenFiscal?.descripcion}`,
                    style: "textoChico",
                    alignment: "center",
                  },
                ],
              ]
            : []),
          ...(tipoComprobante
            ? [
                [
                  {
                    text: textoComprobante, 
                    style: "textoChico",
                    alignment: "center",
                  },
                ],
              ]
            : []),
        ],
      },
      layout: "noBorders",
    },

    terceraColumna,
  ];
};
